// What the photo card in the Foto-Bibliothek shows next to the file size. Pure, so the order is unit-tested:
// posts first, then fetch error and the terminal n8n states, and only then the quiet `received` fallback (a hotel
// photo stored directly). Review he-int R2 M4: the `received` fallback used to hide failures and the retry button.
export type PhotoCardState = "posts" | "fetch-error" | "failed" | "empty" | "received" | "processing";

export function photoCardState(p: {
  postsCount: number;
  isError: boolean;
  received: boolean;
  n8nProcessingStatus?: string | null;
}): PhotoCardState {
  if (p.postsCount > 0) return "posts";
  if (p.isError) return "fetch-error";
  if (p.n8nProcessingStatus === "failed") return "failed";
  if (p.n8nProcessingStatus === "completed") return "empty";
  // A received photo that is not (or no longer) on its way through n8n: "Bei Ihrem Team" / its topic.
  if (p.received && p.n8nProcessingStatus !== "sent" && p.n8nProcessingStatus !== "processing") return "received";
  return "processing";
}
